// import '../../node_modules/lazysizes/lazysizes';
import './components/toggle-nav';
import Masonry from 'masonry-layout/masonry';
import Swiper, { EffectFade, Autoplay, Navigation, Pagination } from 'swiper';
import Headroom from 'headroom.js';

const header = document.querySelector('#masthead');
const headroom = new Headroom(header);
headroom.init();

Swiper.use([Navigation, Pagination, EffectFade, Autoplay]);
const swiper = new Swiper('.swiper', {
  // effect: 'fade',
  speed: 1000,
  loop: true,
  // fadeEffect: {
  //   crossFade: true,
  // },
  // autoplay: {
  //   delay: 2000,
  // },
  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

const grid = document.querySelector('.grid');
if (grid) {
  const msnry = new Masonry(grid, {
    itemsSelector: '.grid-item',
    columnWidth: '.grid-sizer',
    percentPosition: true,
    gutter: 20,
  });
}

const valeurs = document.querySelector('.svg-valeurs');

if (valeurs) {
  const hexas = valeurs.querySelectorAll('.hexa');

  hexas.forEach((hexa) => {
    hexa.addEventListener('click', () => {
      const activeHexas = valeurs.querySelector('.hexa.-active');
      const valeur = hexa.id;
      const activeTargets = document.querySelector('.item-valeur.-visible');
      const target = document.querySelector('[data-valeur="' + valeur + '"]');
      activeHexas && activeHexas.classList.remove('-active');
      hexa.classList.add('-active');
      activeTargets.classList.remove('-visible');
      target.classList.add('-visible');
    });
  });
}

const methodeM = document.querySelector('.svg-methode.-mobile');

if (methodeM) {
  const hexas = methodeM.querySelectorAll('.hexa');

  hexas.forEach((hexa) => {
    hexa.addEventListener('click', () => {
      const activeHexas = methodeM.querySelector('.hexa.-active');
      const methode = hexa.dataset.id;
      const activeTargets = document.querySelector('.item-methode.-visible');
      const target = document.querySelector('[data-methode="' + methode + '"]');
      activeHexas && activeHexas.classList.remove('-active');
      hexa.classList.add('-active');
      activeTargets.classList.remove('-visible');
      target.classList.add('-visible');
    });
  });
}

const methodeD = document.querySelector('.svg-methode.-desktop');

if (methodeD) {
  const hexas = methodeD.querySelectorAll('.hexa');

  hexas.forEach((hexa) => {
    hexa.addEventListener('click', () => {
      const activeHexas = methodeD.querySelector('.hexa.-active');
      const methode = hexa.dataset.id;
      const activeTargets = document.querySelector('.item-methode.-visible');
      const target = document.querySelector('[data-methode="' + methode + '"]');
      activeHexas && activeHexas.classList.remove('-active');
      hexa.classList.add('-active');
      activeTargets.classList.remove('-visible');
      target.classList.add('-visible');
    });
  });
}

const equipiers = document.querySelectorAll('.item-equipe');
const placeholder = document.querySelector('.placeholder');

placeholder &&
  equipiers &&
  equipiers.forEach((equipier, index) => {
    equipier.addEventListener('click', () => {
      const visiblePlaceholder = document.querySelector(
        '.placeholder.-visible'
      );
      const openEquipier = document.querySelector('[data-open="yep"]');

      if (equipier.dataset.open == 'nope') {
        const nom = equipier.dataset.nom;
        const fonction = equipier.dataset.fonction;
        const bio = equipier.dataset.bio;
        const parentIndex = equipier.dataset.index;
        const placeholderNom = placeholder.querySelector('.nom');
        const placeholderFonction = placeholder.querySelector('.fonction');
        const placeholderBio = placeholder.querySelector('.bio');

        if (openEquipier) {
          openEquipier.dataset.open = 'nope';
        }

        placeholderNom.textContent = nom;
        placeholderFonction.textContent = fonction;
        placeholderBio.innerHTML = bio;

        visiblePlaceholder && visiblePlaceholder.classList.remove('-visible');
        placeholder.classList.add('-visible');
        placeholder.style.setProperty('--order-if-one', parseInt(parentIndex));

        for (let step = 3; step <= 12; step = step + 2) {
          if (parentIndex < step) {
            placeholder.style.setProperty('--order-if-two', step - 1);
            break;
          }
        }
        for (let step = 4; step <= 12; step = step + 3) {
          if (parentIndex < step) {
            placeholder.style.setProperty('--order-if-three', step - 1);
            break;
          }
        }

        equipier.dataset.open = 'yep';
      } else {
        visiblePlaceholder && visiblePlaceholder.classList.remove('-visible');

        equipier.dataset.open = 'nope';
      }
    });
  });
